<template>
  <div class="parking-space-container">
    <div class="page-content">
      <!-- 页面标题 -->
      <div class="page-title">{{ $t('listParkingSpace.parkingSpaceInfo') }}</div>

      <!-- 工具栏 -->
      <div class="toolbar">
        <el-button class="add-btn" @click="openAddParkingSpaceModal">
          <i class="el-icon-plus"></i>
          {{ $t('listParkingSpace.add') }}
        </el-button>
        <el-button class="add-btn batch-add-btn" @click="openBatchAddParkingSpaceModal">
          <i class="el-icon-plus"></i>
          {{ $t('listParkingSpace.batchAdd') }}
        </el-button>
        <el-button class="icon-reset-btn" @click="resetParkingSpaceMethod">
          <i class="el-icon-refresh-right"></i>
        </el-button>

        <div class="filter-group parking-space-filter-group">
          <el-select v-model="listParkingSpaceInfo.conditions.paId"
            :placeholder="$t('listParkingSpace.parkingLotPlaceholder')" class="filter-select" clearable>
            <el-option v-for="item in parkingAreas" :key="item.paId" :label="item.num" :value="item.paId" />
          </el-select>
          <el-input v-model.trim="listParkingSpaceInfo.num"
            :placeholder="$t('listParkingSpace.parkingSpaceNumPlaceholder')" class="filter-input" clearable
            @keyup.enter.native="queryParkingSpaceMethod" />
          <el-select v-model="listParkingSpaceInfo.conditions.state"
            :placeholder="$t('listParkingSpace.parkingSpaceStatePlaceholder')" class="filter-select" clearable>
            <el-option :label="$t('listParkingSpace.parkingSpaceStatePlaceholder')" value="" />
            <el-option :label="$t('listParkingSpace.forRent')" value="H" />
            <el-option :label="$t('listParkingSpace.free')" value="F" />
          </el-select>
        </div>

        <div class="toolbar-right">
          <el-button class="search-btn" @click="queryParkingSpaceMethod">
            <i class="el-icon-search"></i>
            {{ $t('common.search') }}
          </el-button>
        </div>
      </div>

      <!-- 列表 -->
      <el-table :data="listParkingSpaceInfo.parkingSpaces" stripe class="data-table" v-loading="loading">
        <el-table-column prop="communityName" label="所在小区" align="center" min-width="200"></el-table-column>
        <el-table-column prop="areaNum" :label="$t('listParkingSpace.parkingLot')" align="center"
          min-width="212"></el-table-column>
        <el-table-column prop="num" :label="$t('listParkingSpace.parkingSpace')" align="center"
          min-width="280"></el-table-column>
        <el-table-column :label="$t('listParkingSpace.parkingSpaceState')" align="center" min-width="216">
          <template slot-scope="scope">
            <span :class="['status-tag', getStateClass(scope.row.state)]">{{ viewParkingSpaceState(scope.row.state)
              }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="parkingTypeName" :label="$t('listParkingSpace.parkingSpaceType')" align="center"
          min-width="240"></el-table-column>
        <el-table-column prop="area" :label="$t('listParkingSpace.area')" align="center"
          min-width="202"></el-table-column>
        <el-table-column prop="createTime" :label="$t('listParkingSpace.createTime')" align="center"
          min-width="280"></el-table-column>
        <el-table-column :label="$t('listParkingSpace.operation')" align="center" min-width="150">
          <template slot-scope="scope">
            <el-button type="text" class="action-btn edit-btn" @click="openEditParkingSpaceModel(scope.row)">
              {{ $t('listParkingSpace.modify') }}
            </el-button>
            <el-button type="text" class="action-btn delete-btn" @click="openDelParkingSpaceModel(scope.row)">
              {{ $t('listParkingSpace.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange"
        :current-page="listParkingSpaceInfo.currentPage" :page-sizes="[10, 20, 30, 50]"
        :page-size="listParkingSpaceInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="listParkingSpaceInfo.total" class="pagination-bar"></el-pagination>
    </div>

    <!-- 子组件 -->
    <add-parking-space ref="addParkingSpace" @success="handleAddSuccess" />
    <edit-parking-space ref="editParkingSpace" @success="handleEditSuccess" />
    <delete-parking-space ref="deleteParkingSpace" @success="handleDeleteSuccess" />
    <choose-parking-area ref="chooseParkingArea" @choose="handleChooseParkingArea" />
    <batch-add-parking-space ref="batchAddParkingSpace" @success="handleBatchAddSuccess" />
  </div>
</template>

<script>
import { listParkingSpaces, listParkingAreas } from '@/api/car/listParkingSpaceApi'
import AddParkingSpace from '@/components/car/addParkingSpace'
import EditParkingSpace from '@/components/car/editParkingSpace'
import DeleteParkingSpace from '@/components/car/deleteParkingSpace'
import ChooseParkingArea from '@/components/car/chooseParkingArea'
import BatchAddParkingSpace from '@/components/car/batchAddParkingSpace'

export default {
  name: 'ListParkingSpace',
  components: {
    AddParkingSpace,
    EditParkingSpace,
    DeleteParkingSpace,
    ChooseParkingArea,
    BatchAddParkingSpace
  },
  data() {
    return {
      loading: false,
      parkingAreas: [],
      listParkingSpaceInfo: {
        parkingSpaces: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        num: '',
        moreCondition: false,
        conditions: {
          psId: '',
          area: '',
          paId: '',
          areaNum: '',
          state: ''
        }
      }
    }
  },
  created() {
    this.loadParkingAreas()
    this.loadParkingSpaceData()
  },
  methods: {
    async loadParkingSpaceData() {
      try {
        this.loading = true
        const params = {
          page: this.listParkingSpaceInfo.currentPage,
          row: this.listParkingSpaceInfo.pageSize,
          num: this.listParkingSpaceInfo.num,
          psId: this.listParkingSpaceInfo.conditions.psId,
          area: this.listParkingSpaceInfo.conditions.area,
          paId: this.listParkingSpaceInfo.conditions.paId,
          state: this.listParkingSpaceInfo.conditions.state
        }

        const res = await listParkingSpaces(params)
        this.listParkingSpaceInfo.parkingSpaces = res.parkingSpaces
        this.listParkingSpaceInfo.total = res.total
      } catch (error) {
        this.$message.error(this.$t('common.loadError'))
      } finally {
        this.loading = false
      }
    },

    viewParkingSpaceState(state) {
      if (state === 'S') return this.$t('listParkingSpace.forSale')
      if (state === 'H') return this.$t('listParkingSpace.forRent')
      if (state === 'F') return this.$t('listParkingSpace.free')
      return 'Unknown'
    },

    getStateClass(state) {
      if (state === 'S') return 'state-sale'
      if (state === 'H') return 'state-rent'
      if (state === 'F') return 'state-free'
      return ''
    },

    async loadParkingAreas() {
      try {
        const params = {
          page: 1,
          row: 50
        }
        const res = await listParkingAreas(params)
        this.parkingAreas = res.parkingAreas || []
      } catch (error) {
        this.$message.error(this.$t('common.loadError'))
      }
    },

    toggleMoreCondition() {
      this.listParkingSpaceInfo.moreCondition = !this.listParkingSpaceInfo.moreCondition
    },

    queryParkingSpaceMethod() {
      this.listParkingSpaceInfo.currentPage = 1
      this.loadParkingSpaceData()
    },

    resetParkingSpaceMethod() {
      this.listParkingSpaceInfo.conditions = {
        psId: '',
        area: '',
        paId: '',
        areaNum: '',
        state: ''
      }
      this.listParkingSpaceInfo.num = ''
      this.loadParkingSpaceData()
    },

    openChooseParkingArea() {
      this.$refs.chooseParkingArea.open()
    },

    openAddParkingSpaceModal() {
      this.$refs.addParkingSpace.open()
    },

    openEditParkingSpaceModel(row) {
      this.$refs.editParkingSpace.open(row)
    },

    openDelParkingSpaceModel(row) {
      this.$refs.deleteParkingSpace.open(row)
    },

    openBatchAddParkingSpaceModal() {
      this.$refs.batchAddParkingSpace.open()
    },

    handleChooseParkingArea(parkingArea) {
      this.listParkingSpaceInfo.conditions.paId = parkingArea.paId
      this.listParkingSpaceInfo.conditions.areaNum = parkingArea.num
    },

    handleAddSuccess() {
      this.loadParkingSpaceData()
    },

    handleEditSuccess() {
      this.loadParkingSpaceData()
    },

    handleDeleteSuccess() {
      this.loadParkingSpaceData()
    },

    handleBatchAddSuccess() {
      this.loadParkingSpaceData()
    },

    handlePageChange(page) {
      this.listParkingSpaceInfo.currentPage = page
      this.loadParkingSpaceData()
    },

    handleSizeChange(size) {
      this.listParkingSpaceInfo.pageSize = size
      this.loadParkingSpaceData()
    }
  }
}
</script>

<style scoped>
  .parking-space-container {
    padding: 20px;
    background-color: #EBF2FA;
    min-height: calc(100vh - 84px);
    font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
  }

  .page-content {
    background: #FFFFFF;
    border-radius: 12px;
    padding: 22px 24px;
  }

  .page-title {
    font-size: 16px;
    font-family: 'PingFang SC', sans-serif;
    font-weight: 600;
    color: #1D2129;
    padding-bottom: 20px;
    border-bottom: 1px solid #DCE6F5;
    margin-bottom: 20px;
    text-align: left;
  }

  .toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;

    .add-btn {
      width: 90px;
      height: 38px;
      border-radius: 10px;
      background: #0E76FF;
      border: none;
      color: #FFFFFF;
      font-family: 'Inter', 'PingFang SC', sans-serif;
      font-weight: 500;
      font-size: 14px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;

      &:hover {
        background: #1C99FF;
      }

      i {
        font-size: 12px;
      }
    }

    .batch-add-btn {
      width: 114px;
    }

    .icon-reset-btn {
      width: 38px;
      height: 38px;
      border-radius: 10px;
      border: 1px solid #DCE6F5;
      background: #FFFFFF;
      color: #8C9BB4;
      padding: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 14px;
      }

      &:hover {
        color: #0E76FF;
        border-color: #0E76FF;
      }
    }

    .filter-group {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;
      justify-content: flex-end;

      .filter-input,
      .filter-select {
        width: 256px;

        ::v-deep .el-input__inner {
          border-radius: 10px;
          border: 1px solid #DCE6F5;
          background: #FFFFFF;
          font-family: 'Inter', 'PingFang SC', sans-serif;
          font-size: 14px;
          color: #1D2129;
          height: 38px;
          line-height: 38px;

          &::placeholder {
            color: #8C9BB4;
          }
        }
      }
    }

    .toolbar-right {
      display: flex;
      align-items: center;
      gap: 12px;

      .search-btn {
        width: 84px;
        height: 38px;
        border-radius: 10px;
        border: 1px solid #0E76FF;
        background: #FFFFFF;
        color: #0E76FF;
        font-family: 'Inter', 'PingFang SC', sans-serif;
        font-weight: 500;
        font-size: 14px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;

        &:hover {
          background: #E8F3FF;
        }

        i {
          font-size: 12px;
        }
      }
    }
  }

  .data-table {
    border-radius: 10px;
    overflow: hidden;

    &::before {
      display: none;
    }

    ::v-deep .el-table__header-wrapper {
      th {
        background-color: #EBF2FA !important;
        color: #364153 !important;
        font-weight: 500;
        font-size: 14px;
        font-family: 'PingFang SC', sans-serif;
        padding: 12px 0;
        height: 50px;
      }
    }

    ::v-deep .el-table__row {
      height: 50px;
      font-size: 14px;
      font-family: 'PingFang SC', sans-serif;
      color: #1D2129;

      td {
        padding: 12px 0;
      }
    }

    ::v-deep .el-table__body tr:nth-child(even) td {
      background-color: #F8FBFF !important;
    }

    ::v-deep .el-table__body tr:hover td {
      background-color: #F5F9FF !important;
    }
  }

  .status-tag {
    display: inline-block;
    padding: 3px 12px;
    border-radius: 8px;
    font-size: 14px;
    font-family: 'PingFang SC', sans-serif;
    font-weight: 400;
    line-height: 1.5;

    &.state-sale {
      background: rgba(14, 118, 255, 0.10);
      color: #0E76FF;
      border: 1px solid #0E76FF;
    }

    &.state-rent {
      background: rgba(14, 118, 255, 0.10);
      color: #0E76FF;
      border: 1px solid #0E76FF;
    }

    &.state-free {
      background: rgba(33, 185, 86, 0.10);
      color: #21B956;
      border: 1px solid #21B956;
    }
  }

  .action-btn {
    font-size: 14px;
    font-family: 'PingFang SC', sans-serif;
    font-weight: 400;
    padding: 0 8px;

    &.edit-btn {
      color: #0E76FF;
    }

    &.delete-btn {
      color: #FB2C36;
    }
  }

  .pagination-bar {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;

    ::v-deep .el-pagination__total {
      font-size: 14px;
      color: #1D2129;
      font-family: 'PingFang SC', sans-serif;
    }

    ::v-deep .el-pager li {
      font-size: 14px;
      font-family: 'Nunito Sans', sans-serif;
      font-weight: 600;
      border-radius: 8px;
      min-width: 32px;
      height: 32px;
      line-height: 32px;

      &.active {
        background: #E8F3FF;
        color: #0E76FF;
      }
    }
  }
</style>
